module.exports = __webpack_public_path__ + "static/media/valor2.a2ea55d7.png";